import { Box } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { MuiButton, MuiButtons, MuiSelect, MuiTextField } from '../../../../components'
import ReportsService from '../../../../services/reports.service'
import { FilterItemWrap } from './style'
import { IconSearchbar } from '../../../../assets/images/icons'

const Filters = ({
  type,
  location,
  history,
  insightsElementId,
  onFilterChange,
  isShadow = false,
  setFilteredData,
  filteredData,
  updateChips,
  parsedRows,
  // filterChange
}) => {
  const form = useRef()

  // const [filters, setFilters] = useState({ ...defaultData })

  const onChangeHandler = (key, value) => {
    const obj = {
      ...filteredData,
      [key]: value,
    }

    // Search is not getting empty
    if (key === 'entityName') {
      obj.attributeName = ''
      obj.driverName = ''
      // obj.searchText = ''
    }
    if (key === 'driverName') {
      obj.attributeName = ''
      // obj.searchText = ''
    }
    if (key === 'attributeName') {
      // obj.searchText = ''
    }
    // setFilters(obj)
    setFilteredData({ ...obj, insightsElementId: insightsElementId })
  }

  const submitPayload = (e) => {
    e.preventDefault()
    // updateQueryString()
    const obj = { ...filteredData, insightsElementId: insightsElementId }
    onFilterChange(obj)
    // filterChange();
    if (
      obj.attributeName === '' &&
      obj.driverName === '' &&
      obj.entityName === '' &&
      obj.searchText === '' &&
      (obj.rows?.length === 0 || (obj.rows?.length === 1 && obj.rows[0]?.text === ''))
    ) {
      updateChips(false)
    } else {
      updateChips({ ...obj })
    }
  }

  useEffect(() => {
    const queryString = location.search
    const params = new URLSearchParams(queryString)

    const verbatimParam = params.get('verbatim')
    const metadataParam = params.get('metadata')

    const isVerbatim =
      verbatimParam === null && metadataParam === null ? true : verbatimParam === 'true'

    const isMetadata =
      verbatimParam === null && metadataParam === null ? true : metadataParam === 'true'

    const obj = {
      entityName: params.get('entityName') || '',
      driverName: params.get('driverName') || '',
      attributeName: params.get('attributeName') || '',
      searchText: params.get('searchText') || '',
      rows: parsedRows() || [],
      verbatim: isVerbatim,
      metadata: isMetadata,
    }
    setFilteredData(obj)
    //   setFilteredData({ ...obj, insightsElementId: insightsElementId })

    if (type === 'showAll') {
      onFilterChange({ ...obj, insightsElementId: insightsElementId })
    }
  }, [])

  const handleInput = (e) => {
    setFilteredData({ ...filteredData, searchText: e.target.value })
    onChangeHandler('searchText', e.target.value)
  }

  // useEffect(() => {
  //   if (defaultData?.searchText !== filteredData?.searchText) {
  //     setFilteredData((prev) => ({ ...prev, searchText: defaultData.searchText }))
  //   }

  //   if (defaultData?.entityName !== filteredData?.entityName) {
  //     setFilteredData((prev) => ({ ...prev, entityName: defaultData.entityName }))
  //   }

  //   if (defaultData?.driverName !== filteredData?.driverName) {
  //     setFilteredData((prev) => ({ ...prev, driverName: defaultData.driverName }))
  //   }

  //   if (defaultData?.attributeName !== filteredData?.attributeName) {
  //     setFilteredData((prev) => ({ ...prev, attributeName: defaultData.attributeName }))
  //   }
  // }, [defaultData])

  return (
    <form
      ref={form}
      onSubmit={submitPayload}
      style={{ display: 'flex', justifyContent: 'space-around', gap: '8px' }}
    >
      {(type === 'showDropdown' || type === 'showAll') && (
        <>
          <BrandCategoryFilter
            insightsElementId={insightsElementId}
            onChange={onChangeHandler}
            value={filteredData?.entityName || ''}
            isShadow={isShadow}
          />
          <DriverFilter
            insightsElementId={insightsElementId}
            onChange={onChangeHandler}
            entityName={filteredData?.entityName || ''}
            value={filteredData?.driverName || ''}
            isShadow={isShadow}
          />
          <AttributeFilter
            insightsElementId={insightsElementId}
            onChange={onChangeHandler}
            entityName={filteredData?.entityName || ''}
            driverName={filteredData?.driverName || ''}
            value={filteredData?.attributeName || ''}
            isShadow={isShadow}
          />
        </>
      )}

      {(type === 'searchOnly' || type === 'showAll') && (
        <>
          <Box
            sx={{
              width: 'calc(100% - (54% - 24px - 70px))',
            }}
          >
            <MuiTextField
              name='searchText'
              placeholder='Search Keywords'
              compact
              onChange={handleInput}
              value={filteredData?.searchText || ''}
              styletype='themeV2'
              InputProps={{
                startAdornment: <IconSearchbar />,
              }}
            />
          </Box>
        </>
      )}

      {type === 'showAll' && (
        <>
          <MuiButton
            className='sandBoxFilter'
            onClick={submitPayload}
            type='submit'
            variant='contained'
            color='gray'
          >
            Filter
          </MuiButton>
        </>
      )}
    </form>
  )
}

export default withRouter(Filters)

const BrandCategoryFilter = ({ insightsElementId, onChange, value, isShadow }) => {
  const [state, setstate] = useState([])

  const getSandboxEntityNamesElementHandler = async () => {
    try {
      const resp = await ReportsService.getSandboxEntityNamesElement({
        insightsElementId: insightsElementId,
      })
      const data = resp.map((item) => ({
        label: item,
        value: item,
      }))
      const filteredData = data.filter((item) => !!item.value)
      if (!filteredData?.length) return
      setstate([{ label: 'All Brands/Categories', value: '' }, ...filteredData])
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getSandboxEntityNamesElementHandler()
  }, [])

  return (
    <FilterItemWrap className={`filterItemWrap ${isShadow ? '' : 'defaultItem'}`}>
      <MuiSelect
        styletype='themeV2'
        name='entityName'
        onChange={(e) => onChange(e.target.name, e.target.value)}
        // title='Brand/Category'
        data={state}
        menuprops={{ style: { maxHeight: '200px', maxWidth: '180px' } }}
        variant={isShadow ? 'outlined' : 'standard'}
        // placeholder='All Brand/Category'
        compact
        selectlabel='label'
        selectvalue='value'
        value={value ?? ''}
        displayEmpty
        renderValue={(selected) => {
          return selected === '' ? <span>All Brands/Categories</span> : selected
        }}
      />
    </FilterItemWrap>
  )
}

const DriverFilter = ({ insightsElementId, onChange, entityName, value, isShadow }) => {
  const [state, setstate] = useState([])

  const getSandboxDriverNamesElementHandler = async () => {
    try {
      const resp = await ReportsService.getSandboxDriverNamesElement({
        insightsElementId: insightsElementId,
        entityName,
      })
      const data = resp.map((item) => ({
        label: item,
        value: item,
      }))
      const filteredData = data.filter((item) => !!item.value)
      if (!filteredData?.length) return
      setstate([{ label: 'All Drivers', value: '' }, ...filteredData])
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    // if(entityName) {
    getSandboxDriverNamesElementHandler()
    // }
  }, [entityName])

  return (
    <FilterItemWrap className={`filterItemWrap ${isShadow ? '' : 'defaultItem'}`}>
      <MuiSelect
        styletype='themeV2'
        name='driverName'
        onChange={(e) => onChange(e.target.name, e.target.value)}
        // title='Driver'
        data={state}
        menuprops={{ style: { maxHeight: '200px', maxWidth: '180px' } }}
        compact
        // disabled={!entityName}
        // placeholder='All Driver'
        // endAdornment
        variant={isShadow ? 'outlined' : 'standard'}
        selectlabel='label'
        selectvalue='value'
        value={value ?? ''}
        displayEmpty
        renderValue={(selected) => {
          return selected === '' ? <span>All Drivers</span> : selected
        }}
      />
    </FilterItemWrap>
  )
}

const AttributeFilter = ({
  insightsElementId,
  onChange,
  entityName,
  driverName,
  value,
  isShadow,
}) => {
  const [state, setstate] = useState([])

  const getSandboxAttributeNamesElementHandler = async () => {
    try {
      const resp = await ReportsService.getSandboxAttributeNamesElement({
        insightsElementId: insightsElementId,
        entityName,
        driverName,
      })
      const data = resp.map((item) => ({
        label: item,
        value: item,
      }))
      const filteredData = data.filter((item) => !!item.value)
      // if (!filteredData?.length) return;
      setstate([{ label: 'All Attributes', value: '' }, ...filteredData])
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getSandboxAttributeNamesElementHandler()
  }, [entityName, driverName])

  return (
    <FilterItemWrap className={`filterItemWrap ${isShadow ? '' : 'defaultItem'}`}>
      <MuiSelect
        styletype='themeV2'
        name='attributeName'
        onChange={(e) => onChange(e.target.name, e.target.value)}
        // title='Attribute'
        data={state}
        compact
        value={value ?? ''}
        // menuprops={{ style: { maxHeight: '200px', maxWidth: '180px' } }}
        // placeholder='All Attribute'
        // endAdornment
        variant={isShadow ? 'outlined' : 'standard'}
        selectlabel='label'
        selectvalue='value'
        displayEmpty
        renderValue={(selected) => {
          return selected === '' ? <span>All Attributes</span> : selected
        }}
      />
    </FilterItemWrap>
  )
}

const SubAttributeFilter = ({
  insightsElementId,
  onChange,
  entityName,
  driverName,
  attributeName,
  value,
  isShadow,
}) => {
  const [state, setstate] = useState([])

  const getSandboxSubAttributeNamesElementHandler = async () => {
    try {
      const resp = await ReportsService.getSandboxSubAttributeNamesElement({
        insightsElementId: insightsElementId,
        entityName,
        driverName,
        attributeName,
      })
      const data = resp.map((item) => ({
        label: item,
        value: item,
      }))
      const filteredData = data.filter((item) => !!item.value)
      if (!filteredData?.length) return
      setstate([{ label: '', value: '' }, ...filteredData])
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getSandboxSubAttributeNamesElementHandler()
  }, [entityName, driverName])

  return (
    <FilterItemWrap className={`filterItemWrap ${isShadow ? '' : 'defaultItem'}`}>
      <MuiSelect
        styletype='themeV2'
        name='subAttributeName'
        onChange={(e) => onChange(e.target.name, e.target.value)}
        // title='Sub Attribute'
        data={state}
        compact
        value={value || null}
        menuprops={{ style: { maxHeight: '200px', maxWidth: '180px' } }}
        placeholder='Sub Attribute'
        // endAdornment
        variant={isShadow ? 'outlined' : 'standard'}
        selectlabel='label'
        selectvalue='value'
      />
    </FilterItemWrap>
  )
}
